import { builder, createElHelpers } from '../../internal/helpers/index.js';
import { derived } from 'svelte/store';
import { createListbox } from '../listbox/create.js';
const { name } = createElHelpers('select');
export function createSelect(props) {
    const listbox = createListbox({ ...props, builder: 'select' });
    const group = builder(name('group'), {
        returned: () => {
            return (groupId) => ({
                role: 'group',
                'aria-labelledby': groupId,
            });
        },
    });
    const groupLabel = builder(name('group-label'), {
        returned: () => {
            return (groupId) => ({
                id: groupId,
            });
        },
    });
    const selectedLabel = derived(listbox.states.selected, ($selected) => {
        if (Array.isArray($selected)) {
            return $selected.map((o) => o.label).join(', ');
        }
        return $selected?.label ?? '';
    });
    return {
        ...listbox,
        elements: {
            ...listbox.elements,
            group,
            groupLabel,
        },
        states: {
            ...listbox.states,
            selectedLabel,
        },
    };
}
